/* eslint-disable react/no-danger */

import { MortgageAnnotations } from '@cian/adfox-templates';
import { Label } from '@cian/ui-kit';

import React from 'react';

import styles from './MainpageBrand.css';
import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { Link } from '../../../../Link';
import { FILTERS_BLOCK_HEIGHT } from '../../contansts';
import { Marquee } from '../../../../Marquee';

export interface IMainpageBrandProps {
  url: string;
  logoImageUrl: string;
  substrateNotNeeded: string | undefined;
  buttonText: string;
  label: string | undefined;
  mortgageWarning: string | undefined;
  mortgageTermsWarning: string | undefined;
  sizes: TAdFoxBannerCompleteSizes;
  sanitizedActionText: string;
  sanitizedName: string | undefined;
  sanitizedPhone: string | undefined;
  sanitizedInfo: string | undefined;
  note: string | undefined;
}

export const MainpageBrand: React.FC<IMainpageBrandProps> = ({
  url,
  logoImageUrl,
  substrateNotNeeded,
  buttonText,
  label,
  mortgageWarning,
  mortgageTermsWarning,
  sanitizedActionText,
  sanitizedInfo,
  sanitizedName,
  sanitizedPhone,
  note,
}) => {
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <div className={styles['c-filters-brand']} data-testid="MainpageBrand">
      <div className={styles['c-filters-brand-info']}>
        <a
          className={styles['c-filters-brand-flag']}
          href={url}
          target="_blank"
          role="img"
          rel="noopener noreferrer"
          dangerouslySetInnerHTML={{ __html: sanitizedActionText }}
        />
        <a
          className={substrateNotNeeded === '1' ? styles['c-filters-brand-logo'] : styles['c-filters-brand-logo-bg']}
          href={url}
          rel="noopener noreferrer"
          role="img"
          target="_blank"
        >
          <img src={logoImageUrl} alt="logo" />
        </a>
        <div className={styles['c-filters-brand-left']}>
          {(sanitizedName || sanitizedInfo) && (
            <a
              className={styles['c-filters-brand-link']}
              href={url}
              rel="noopener noreferrer"
              role="button"
              target="_blank"
            >
              {sanitizedName && (
                <h3 className={styles['c-filters-brand-title']} dangerouslySetInnerHTML={{ __html: sanitizedName }} />
              )}
              {sanitizedInfo && (
                <p className={styles['c-filters-brand-text']} dangerouslySetInnerHTML={{ __html: sanitizedInfo }} />
              )}
            </a>
          )}
          <div className={styles['c-filters-brand-prices']}>
            <Link href={url} className={styles['c-filters-brand-button']} rel="noopener noreferrer" target="_blank">
              {buttonText}
            </Link>
            {sanitizedPhone && (
              <span className={styles['c-filters-brand-tel']} dangerouslySetInnerHTML={{ __html: sanitizedPhone }} />
            )}
          </div>
        </div>
      </div>
      {!!note && (
        <div className={styles['disclaimer']}>
          <Marquee text={note} />
        </div>
      )}
      {withMortgageAnnotations && (
        <div className={styles['mortgage-disclaimer']}>
          <MortgageAnnotations
            height={FILTERS_BLOCK_HEIGHT}
            mortgageWarning={mortgageWarning}
            mortgageTermsWarning={mortgageTermsWarning}
          />
        </div>
      )}
      {!!label && (
        <div className={styles['label']}>
          <Label color="var(--decorative-theme-white, #ffffff)" background="var(--overlay-default, rgba(0, 0, 0, 0.4)">
            {label}
          </Label>
        </div>
      )}
    </div>
  );
};
